import React from "react";
import { CalendarDays } from "lucide-react";

export default function DispatchCaptureDispatchGroupHeader({
  count = 0,
  countLabel = "",
  label = "",
}) {
  const resolvedCountLabel = countLabel || (
    Number.isFinite(Number(count)) && Number(count) > 0 ? String(count) : ""
  );

  return (
    <header
      className="flex items-center justify-between gap-3 rounded-[12px] border border-slate-300 bg-slate-200/90 px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.65)]"
      data-dispatch-capture-dispatch-group-header="true"
    >
      <div className="flex min-w-0 items-center gap-2 text-[0.95rem] font-extrabold tracking-[-0.02em] text-slate-950">
        <CalendarDays className="shrink-0 text-slate-700" size={16} aria-hidden="true" />
        <h3 className="m-0 truncate">{label}</h3>
      </div>
      {resolvedCountLabel ? (
        <span className="shrink-0 rounded-full border border-slate-300 bg-white px-2.5 py-1 text-[0.68rem] font-bold text-slate-600">
          {resolvedCountLabel}
        </span>
      ) : null}
    </header>
  );
}
